import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

export interface ProjectDownloadingDialogData {
    downloadUrl: number;
}

@Component({
    templateUrl: './project-downloading-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose],
})
export class ProjectDownloadingDialogComponent {
    data = inject<ProjectDownloadingDialogData>(MAT_DIALOG_DATA);

    constructor() {
    }
}
